import script from "./MessageForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageForm.vue?vue&type=script&lang=ts&setup=true"

import "./MessageForm.vue?vue&type=style&index=0&id=7ca07bd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca07bd0"]])

export default __exports__